module.exports = __webpack_public_path__ + "static/media/home-bridal.2bdbaf19.jpeg";